import React, {Fragment, useState} from "react";
import uuid from 'uuid/v4';
import PropTypes from 'prop-types';

const Formulario = ({crearCita}) =>{

 //Crear el state de Citas
 const [cita, actualizarCita] = useState({
     mascota:'',
     propietario:'',
     fecha:'',
     hora:'',
     sintomas:''
 });

 //state de error

 const [error, actualizarError] = useState(false);

        // funcion que dice cuando escribimos en los inputs
    const actualizarState = e =>{
        actualizarCita({
            ...cita,
            [e.target.name] : e.target.value
        });
    }
    // extraer los valores
    const {mascota,propietario,fecha,hora,sintomas} = cita;

// cuando clickea el boton de enviar
    const submitCita = e =>{
       e.preventDefault();

       //Validar
        if (mascota.trim() === '' || propietario.trim() === '' || fecha.trim() === '' || hora.trim() === '' ||
        sintomas.trim() === '' ){
            actualizarError(true);
            return;
        }
        //eliminar mensaje de errir previo
        actualizarError(false);


       //asignar ID
        cita.id =uuid();
        

       //crear Cita
        crearCita(cita);



       //Reiniciar Form
        actualizarCita({
        mascota:'',
        propietario:'',
        fecha:'',
        hora:'',
        sintomas:''
        });

    }

    return(
        <Fragment>      
            <h2>Crear Cita </h2> 

            {error ? <p className = "alerta-error">Todos los Campos son Obligatorios</p> :null}
            <form onSubmit = {submitCita}>
                <label>Nombre Mascota</label>
                <input
                    type="text"
                    name ="mascota"
                    className="u-full-width"
                    placeholder="Nombre Mascota"
                    onChange = {actualizarState}
                    value = {mascota}
                />
                <label>Propietario</label>
                <input
                    type="text"
                    name ="propietario"
                    className="u-full-width"
                    placeholder="Nombre propietario"
                    onChange = {actualizarState}
                    value = {propietario}
                />
                <label>Fecha</label>
                <input
                    type="date"
                    name ="fecha"
                    className="u-full-width"
                    onChange = {actualizarState}
                    value = {fecha}
                />
                  <label>Hora</label>
                <input
                    type="time"
                    name ="hora"
                    className="u-full-width"
                    onChange = {actualizarState}
                    value = {hora}
                    />
                      <label>Sintomas</label>
                <textarea
                 className="u-full-width"
                 name="sintomas"
                 onChange = {actualizarState}
                 value = {sintomas}
                ></textarea>
                <button
                type="submit"
                className="u-full-width button-primary"
                >Agregar Cita</button>
            </form>

        </Fragment>
    );
}
Formulario.propTypes = {
    crearCita:PropTypes.func.isRequired
}

export default Formulario;